module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/studio-suns_access_03-f81b70346fdb4dc3b34e5dc34bacab6d.jpg";